<template>
    <div class="row">
        <div class="col-sm-12">
            <h4 class="d-inline">{{ $t('My company at a glance') }}</h4>
        </div>
        <div class="col-sm-12 mt-3 pl-3 my-team-header-buttons">
          <fg-input class="btn-one-size-dropdown btn-one-size mr-2">
              <el-select size="large"
                          class="select-primary"
                          :placeholder="$t('Time frame')"
                          fullWidth
                          @input="setMonthsFilter"
                          :value="months">
                  <el-option v-for="option in monthsOptions"
                              :value="option.value"
                              :label="$t(option.label)"
                              :key="option.value">
                  </el-option>
              </el-select>
          </fg-input>
        </div>
        <div v-for="dataset in items"
             v-if="dataset.question !== null"
             class="col-md-6"
             :class="{ 'col-xl-3 col-sm-6': total > 2, 'col-lg-6': total === 2 }">
            <basic-chart :title="dataset.question.title | languageString" :data="dataset" :badge-value="dataset.average"/>
        </div>
    </div>
</template>

<script>
  import { Button, Select, Option } from 'element-ui'
  import { mapActions, mapState } from 'vuex'
  import BasicChart from '../../Dashboard/Components/BasicChart'
  import PButton from '../../UIComponents/Button'
  import size from 'lodash/size'

  export default {
    name: 'Team',
    components: {
      PButton,
      BasicChart,
      [Button.name]: Button,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data () {
      return {}
    },
    mounted () {
      this.init()
    },
    computed: {
      ...mapState('dashboard', {
        items: state => state.items,
        total: state => size(state.items),
        months: state => state.months,
        monthsOptions: state => state.monthsOptions
      })
    },
    methods: {
      ...mapActions('dashboard', ['getItems', 'setMonthsFilter', 'initPackageMonthsOptions']),
      init () {
        this.initPackageMonthsOptions(this.$auth.user.customer.settings.contract.packageType)
        this.getItems({
          months: this.months
        })
      }
    },
    watch: {
      months (val) {
        if (val) {
          this.init()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @media (max-width: 590px) {
    .btn-one-size-dropdown {
      width: 100%;
      padding-left: 0px;
      padding-right: 0px;
      margin-right: 5px !important;
    }
  }
</style>